import { Colors, Shadows } from 'enums';
import styled from 'styled-components';
import { CSS_FOR_SCROLL_WITH_PADDING } from 'styles/customScrollWithPadding';

export const IconBubble = styled.div`
  position: absolute;
  height: 10px;
  width: 10px;
  border-radius: 99px;
  border: 2px solid ${Colors.white};
  right: 17px;
  top: 14px;
  background-color: ${Colors.yellow1};
`;

export const NotificationsButton = styled.div<{ active: boolean }>`
  position: relative;
  border-radius: 10px;
  padding: 11px;
  background-color: ${Colors.white};
  cursor: pointer;
  height: 56px;
  width: 56px;
  border: 1px solid ${({ active }) => (active ? Colors.yellow1 : 'transparent')};

  &:hover {
    background-color: ${Colors.gray5};
  }

  &:hover ${IconBubble} {
    border: 2px solid ${Colors.gray5};
  }
`;

export const IconWrapper = styled.div`
  position: relative;
`;

export const NotificationsMenuWrapper = styled.div`
  position: relative;
`;

export const NotificationsMenu = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  position: absolute;
  border-radius: 10px;
  padding: 20px;
  width: 460px;
  max-height: 544px;
  background-color: ${Colors.white};
  box-shadow: ${Shadows.darkShadow};
  right: 0;
  top: calc(100% + 9px);

  overflow-y: auto;
  ${CSS_FOR_SCROLL_WITH_PADDING}
`;
